import { Link } from 'react-router-dom';
import styled from 'styled-components';

import { AuthPage } from 'auth/components/AuthPage';
import { WhiteBox, Spacer } from 'shared/components/Layout';
import { ButtonPrimaryCSS } from 'shared/components/Button';
import { H1, H2, P } from 'shared/components/Typography';
import { AuthHeader } from 'auth/components/AuthHeader';
import Logo from 'shared/components/Logo';
import MetaTitle from 'shared/components/MetaTitle';

const ContentContainer = styled.div`
  width: 552px;
  text-align: center;

  h1 {
    margin-bottom: 0;
  }
`;

const Title = styled(H2)`
  font-size: 80px;
  line-height: 1;
  color: ${({ theme }) => theme.heather};
`;

const SpanBlock = styled.span`
  display: block;
`;

const HomeButton = styled(Link)`
  ${ButtonPrimaryCSS};
  display: inline-flex;
`;

export function NotFoundPage() {
  return (
    <AuthPage flex middle center>
      <MetaTitle title="404 Page Not Found | Plato Connect" />

      <AuthHeader>
        <Logo />
      </AuthHeader>

      <ContentContainer>
        <WhiteBox>
          <Title>404</Title>

          <H1>Oops. Page Not Found</H1>
          <Spacer h="8px" />

          <P>
            We can’t seem to find that page you are looking for.
            <SpanBlock>Click on the button below.</SpanBlock>
          </P>
          <Spacer h="32px" />

          <HomeButton to="/">Go home</HomeButton>
        </WhiteBox>
      </ContentContainer>
    </AuthPage>
  );
}
